import React, { PropTypes } from 'react';
import { icon } from './../../../icons/icons';

const Breadcrumbs = (props) => {
    const { app } = props;

    return (
        <div className="c-breadcrumbs">
            <a href={(window.fos === undefined) ? '#' : Routing.generate('app_inquiry.get_all')} className="c-breadcrumbs__link">
                <span className="c-breadcrumbs__icon"> {icon.homeSmall()} </span>
                Home
            </a>
            <a href={(window.fos === undefined) ? '#' : Routing.generate('app_inquiry.get_all')} className="c-breadcrumbs__link">
                Quick Response
            </a>
            <a className="c-breadcrumbs__link">{(app.name) ? app.name : 'Creating new quick response'}</a>
        </div>
    );
};

Breadcrumbs.propTypes = {
    app: PropTypes.object.isRequired,
};

export default Breadcrumbs;



// WEBPACK FOOTER //
// ./src/_app/quick_response/components/Content/UI/Breadcrumbs.jsx